var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTotalAddresses = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 81,
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427320999",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 523",
    d: "M0 -14.0615C0 -17.3412 2.65876 -20 5.93851 -20H76.0618C79.3415 -20 82.0003 -17.3412 82.0003 -14.0615V49.9144C82.0003 54.0535 76.0622 54.7252 75.1377 50.6907C74.313 47.0921 69.1875 47.0921 68.3628 50.6907L66.6252 58.273C65.3775 63.7175 57.6229 63.7175 56.3752 58.273C55.1275 52.8285 47.3729 52.8285 46.1252 58.273C44.8775 63.7175 37.1228 63.7175 35.8751 58.273C34.6274 52.8285 26.8728 52.8285 25.6251 58.273C24.3774 63.7175 16.6228 63.7175 15.3751 58.273L13.6374 50.6907C12.8128 47.0921 7.6873 47.0921 6.86263 50.6907C5.93807 54.7252 0 54.0535 0 49.9144V-14.0615Z",
    fill: "#B1C5FB"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 524",
    x: 13.3281,
    y: -1.36133,
    width: 7.45457,
    height: 7.45457,
    fill: "#3C6FF5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 526",
    x: 13.3281,
    y: 13.5449,
    width: 7.45457,
    height: 7.45457,
    fill: "#3C6FF5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 528",
    x: 13.3281,
    y: 28.4502,
    width: 7.45457,
    height: 7.45457,
    fill: "#3C6FF5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 525",
    x: 28.2324,
    y: -1.36133,
    width: 40.2547,
    height: 7.54775,
    fill: "#3C6FF5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 527",
    x: 28.2324,
    y: 13.5449,
    width: 40.2547,
    height: 7.54775,
    fill: "#3C6FF5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 529",
    x: 28.2324,
    y: 28.4502,
    width: 40.2547,
    height: 7.54775,
    fill: "#3C6FF5"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTotalAddresses);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/total_addresses.7296ed5a07c6eb67d915b9e102588a4c.svg";